export default __webpack_public_path__ + "static/media/cloudcraft.37046db5.svg";